<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deletePatient" @cancel="cancel" />
    <div class="table-wrapper">
    <v-data-table
      v-if="!loading"
      :headers="headers"
      :items="patients"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat class="toolbar-custom">
          <v-toolbar-title class="toolbar-title">
            <v-icon class="mr-2" color="#aa00ff">mdi-account-group</v-icon>
            Patients
          </v-toolbar-title>
          <v-divider class="mx-3" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- <export-btn></export-btn> -->
          <v-btn
            @click="$router.push('/patient')"
            class="action-btn mr-2"
            large
            rounded
          >
            <v-icon left>mdi-refresh</v-icon>View All
          </v-btn>
          <v-btn
            @click="showFilterModal = true"
            class="action-btn-primary mr-2"
            large
            rounded
          >
            <v-icon left>mdi-filter-variant</v-icon>Filter
          </v-btn>
          <v-btn
            @click="$router.push('/patient/create')"
            class="action-btn-success"
            large
            rounded
          >
            <v-icon left>mdi-plus-circle-outline</v-icon>New Item
          </v-btn>
        </v-toolbar>
      </template>
      

      <template v-slot:header="{ props: { headers } }">
        <thead class="table-header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="table-header-cell"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ index, item }">
        <tr class="table-row">
          <!-- <td v-if="item.app_refer_status!=1">
              <svg style="color:darkgray;"  xmlns="http://www.w3.org/2000/svg" width="1.5em" height="2em" viewBox="0 0 24 24"><path fill="currentColor" d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6zm-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2"/>
              </svg>
          </td>
          <td v-else>
            <button @click="takeAction(item.dots_patient_id)">
            <svg style="color:red;"  xmlns="http://www.w3.org/2000/svg" width="1.5em" height="2em" viewBox="0 0 24 24"><path fill="currentColor" d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6zm-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2"/>
            </svg>
            </button>
          </td> -->
          <td>{{ page > 1 ? (page - 1) * 30 + (index + 1) : index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>
            <span v-if="item.mdrtb_reg_no">
              {{ item.mdrtb_reg_no }}
            </span>
          </td>
          <td>
            <span v-if="item.mdrtb_reg_year">
              {{ item.mdrtb_reg_year }}
            </span>
          </td>
          <td v-if="item.sex == 1">Male</td>
          <td v-else>Female</td>
          <td>{{ calculateAge(item.dob)}}</td>

          <td v-if="item.pre_enroll == 1">Yes</td>
          <td v-else>No</td>

          <td v-if="item.mdrtb_monopoly==1">No</td>
          <td v-else-if="item.mdrtb_monopoly==2">Yes</td>
          <td v-else>SG</td>

          <td v-if="item.is_auto_nominated==true">Yes</td>
          <td v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-on="on" v-bind="attrs"> Treatment Finished</span>
              </template>
              <span>{{ item.finished_date }}</span>
            </v-tooltip>
          </td>
          <td>{{ item.township }}</td>
         
          <td>
            <!-- <span
              :class="{
                'red accent-3': item.comments.length === 0,
                'green accent-3': item.comments.length != 0,
              }"
              class="px-3 py-1 white--text font-weight-bold"
            >
              {{ item.comments.length }}
            </span> -->
          </td>
          <td v-if="item.remark">{{ item.remark }}</td>
          <td v-else>--</td>
          <td>
            <div class="mr-2">
              <v-btn
                class="white--text"
                depressed
                icon
                :to="`/enroll/clu/${item.id}`"
                v-if="item.diff_finished_change >= 30"
                ><v-icon color="red darken-2"> mdi-message-text </v-icon></v-btn
              >
              
              <v-btn
                @click="goUpdateForm(item)"
                icon
                class="mr-2 edit-btn"
                depressed
              >
                <v-icon color="white"> mdi-pencil-outline </v-icon>
              </v-btn>
              
            </div>
          </td>
        </tr>
      </template>

    </v-data-table>
    </div>
    <div class="text-center py-3 pagination-container">
      <v-pagination
        :length="pageCount"
        v-model="page"
        :total-visible="7"
        color="#aa00ff"
        class="custom-pagination"
      ></v-pagination>
    </div>
    <filter-box
      v-bind:dialog="showFilterModal"
      @cancel="showFilterModal = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";
import FilterBox from "./components/FilterBox.vue";
// import ExportBtn from "./components/ExportBtn.vue";
import { CalculateAge } from "../../mixins/CalculateAge";
export default {
  props: {
    patients: {
      type: Array,
    },
  },
  mixins: [CalculateAge],

  components: {
    ConfirmBox,
    FilterBox,
    // ExportBtn,
  },
  created() {
    if (!this.$route.query.page) {
      this.page = 1;
    } else {
      this.page = parseInt(this.$route.query.page);
    }
  },
  data: () => ({
    showFilterModal: false,
    page: 0,
    itemsPerPage: 30,
    item: {},
    dialog: false,
    headers: [
      // { text: "App Refer", value: "symptom_screening" },
      { text: "No", value: "no", width: "300px", fixed: true },
      { text: "Name", value: "name", width: "300px" },
      { text: "Code", value: "code", width: "300px" },
      { text: "Year", value: "year", width: "300px" },
      { text: "Sex", value: "sex", width: "25%" },
      { text: "Age", value: "age", width: "25%" },
      { text: "Pre Enroll", value: "pre_enroll" },
      { text: "Mono-Poly", value: "monopoly" },
      { text: "Nominated", value: "Nominated" },
      { text: "Township", value: "township" },
      
      { text: "Feedback", value: "feedback" },
      { text: "Remark", value: "support_remark" },

      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Patient", ["pageCount"]),
    ...mapState('Admin',['admin']),

    hasHighSideEffectThree() {
      return this.item.dots_patient.some(patient => 
        patient.dots_visit_date.some(visit => 
          visit.high_side_effect.split(',').includes('3')
        )
      );
    }
  },
  watch: {
    page(newValue) {
      this.$router.push("/patient?page=" + newValue).catch(()=>{});
    },
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletePatient() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("Patient/deletePatient", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "patient-edit",
        params: {
          id: convertNumber,
        },
      });
    },
    takeAction(item) {
      const confirmed = confirm("Take an action?");
      if (confirmed) {
        let dots_patient_id = parseInt(item);
          let data = {
          id: dots_patient_id,
        };
        this.$store
          .dispatch("Patient/actionTakenPatient", data)
          .then(() => (console.log('success')));
      } 
    },
  },
};
</script>

<style scoped>
/* Toolbar Styling */
.toolbar-custom {
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
  border-bottom: 2px solid #e0e0e0;
  padding: 6px 16px;
  min-height: 70px !important;
  height: 70px !important;
}

.toolbar-title {
  font-size: 20px;
  font-weight: 600;
  color: #424242;
  display: flex;
  align-items: center;
}

/* Button Styling */
.action-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.action-btn-primary {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%) !important;
  color: white !important;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.3);
  transition: all 0.3s ease;
}

.action-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(170, 0, 255, 0.4);
}

.action-btn-success {
  background: linear-gradient(135deg, #00c853 0%, #00a844 100%) !important;
  color: white !important;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 200, 83, 0.3);
  transition: all 0.3s ease;
}

.action-btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 200, 83, 0.4);
}

/* Table Header Styling */
/* .table-header {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%);
} */

/* .table-header-cell {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 16px 12px !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.table-header-cell:first-child {
  border-top-left-radius: 8px;
}

.table-header-cell:last-child {
  border-top-right-radius: 8px;
} */

/* Table Row Styling */
.table-row {
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: #f5f5f5 !important;
}

.table-row:nth-child(even) {
  background-color: #fafafa;
}

.table-row:nth-child(even):hover {
  background-color: #f0f0f0 !important;
}

.table-row td {
  padding: 12px !important;
  border-bottom: 1px solid #e0e0e0;
}

/* Edit Button */
.edit-btn {
  background: linear-gradient(135deg, #ff6f00 0%, #e65100 100%) !important;
  transition: all 0.3s ease;
}

.edit-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(255, 111, 0, 0.4);
}

/* Pagination Styling */
.pagination-container {
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

.custom-pagination >>> .v-pagination__item {
  color: #aa00ff;
  font-weight: 500;
}

.custom-pagination >>> .v-pagination__item--active {
  background: #aa00ff !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.3);
}

.custom-pagination >>> .v-pagination__navigation {
  color: #aa00ff;
}

.custom-pagination >>> .v-pagination__navigation:hover {
  background: rgba(170, 0, 255, 0.1);
}

/* Table Wrapper for Horizontal Scrolling */
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

/* Responsive Design */
@media (max-width: 960px) {
  .toolbar-title {
    font-size: 18px;
  }
  
  .action-btn,
  .action-btn-primary,
  .action-btn-success {
    font-size: 12px;
    padding: 8px 12px;
  }
  
  .table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    display: block;
    position: relative;
  }
  
  /* Table Header Responsive */
  .table-header {
    display: table;
    width: 100%;
    min-width: 800px;
    table-layout: fixed;
  }
  
  .table-header-cell {
    font-size: 11px !important;
    padding: 10px 6px !important;
    white-space: nowrap;
    position: sticky;
    top: 0;
    background-color: #fafafa;
    z-index: 2;
    border-bottom: 2px solid #e0e0e0;
  }
  
  /* Table Body Responsive */
  .v-data-table >>> tbody {
    display: table-row-group;
    width: 100%;
    min-width: 800px;
  }
  
  .table-row {
    display: table-row;
    width: 100%;
    min-width: 800px;
  }
  
  .table-row:hover {
    background-color: #f5f5f5 !important;
  }
  
  .table-row td {
    font-size: 11px !important;
    padding: 8px 6px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
    display: table-cell;
    vertical-align: middle;
  }
  
  /* Action buttons in mobile */
  .table-row td:last-child {
    min-width: 100px;
    max-width: none;
  }
  
  .table-row td:last-child .mr-2 {
    display: flex;
    gap: 4px;
  }
  
  /* Make table scrollable horizontally */
  .v-data-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }
  
  .v-data-table >>> .v-data-table__wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    display: block;
  }
  
  .v-data-table >>> table {
    min-width: 800px;
    width: 100%;
    table-layout: fixed;
  }
  
  .v-data-table >>> tbody tr {
    display: table-row;
    width: 100%;
  }
  
  /* Ensure proper scrolling on mobile */
  .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
    height: 8px;
  }
  
  .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background: #aa00ff;
    border-radius: 4px;
  }
  
  .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
    background: #8e00cc;
  }
}

/* Extra small devices */
@media (max-width: 600px) {
  .table-header-cell {
    font-size: 10px !important;
    padding: 8px 4px !important;
  }
  
  .table-row td {
    font-size: 10px !important;
    padding: 6px 4px !important;
    max-width: 120px;
  }
  
  .v-data-table >>> table {
    min-width: 700px;
  }
  
  .table-header {
    min-width: 700px;
  }
  
  .table-row {
    min-width: 700px;
  }
  
  .v-data-table >>> tbody {
    min-width: 700px;
  }
}
</style>